<template>
  <div>
    <el-card>
      <div class="btn-head">
        <el-input
          v-model="searchKeyWord"
          placeholder="搜索姓名或单位"
          style="width: 200px; margin-right: 20px"
        ></el-input>
        <el-button type="primary" @click="handleAddEmployee">添加</el-button>
      </div>
      <!-- 表格 -->
      <el-table
        :data="
          filteredData.slice(
            (currentPage - 1) * pagesize,
            currentPage * pagesize
          )
        "
        style="width: 100%"
        height="600"
        class="diffrow"
        ref="employeeTable"
        @selection-change="handleSelectionChange"
        :default-sort="{ prop: 'userId' }"
        :tree-props="{ children: 'children' }"
        row-key="userId"
      >
        <el-table-column type="selection" width="55" fixed />
        <template v-for="column in employeeTable" :key="column.label">
          <el-table-column
            :prop="column.prop"
            :label="column.label"
            width="200"
            :formatter="formatter"
          >
          </el-table-column>
        </template>
        <el-table-column label="操作" width="200">
          <template #default="scope">
            <el-button type="text" @click="handleReset(scope.$index, scope.row)"
              >重置密码</el-button
            >
            <el-button type="text" @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-popconfirm
              title="确认删除?"
              @confirm="doDelete(scope.$index, scope.row)"
              confirm-button-text="是"
              cancel-button-text="否"
            >
              <template #reference>
                <el-button type="text" @click="handleDelete">删除</el-button>
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-block">
        <el-pagination
          v-model:current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          v-model:page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="filteredData.length"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </el-card>

    <el-dialog
      v-model="showableComp.employeeForm"
      title="添加人员信息"
      width="40%"
    >
      <el-form label-width="120px" :disabled="disableComp.employeeForm">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名">
              <el-input v-model="employeeForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属科室">
              <DepartmentSelect
                ref="departmentSelect"
                v-model="employeeForm.departmentId"
                @departmentId="this.employeeForm.departmentId = $event"
              ></DepartmentSelect>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="参加工作时间">
              <el-date-picker
                v-model="employeeForm.joinTime"
                type="date"
                placeholder="选择日期"
                :locale="zhCn"
                style="width: 190px"
                value-format="YYYY-MM-DD"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="进入部门时间">
              <el-date-picker
                v-model="employeeForm.enterTime"
                type="date"
                placeholder="选择日期"
                :locale="zhCn"
                style="width: 190px"
                value-format="YYYY-MM-DD"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="用户名">
              <el-input
                v-model="employeeForm.username"
                placeholder="可不填写"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="角色">
              <RoleSelect
                :multiple="true"
                v-model="employeeForm.roleId"
                @role="this.employeeForm.roleId = $event"
              ></RoleSelect>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="状态">
              <el-input v-model="employeeForm.state"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否参加考核">
              <AvailableSelect
                v-model="employeeForm.participate"
                @available="this.employeeForm.participate = $event"
              ></AvailableSelect>
            </el-form-item>
          </el-col>
        </el-row>
        <p class="table-note">
          *注意：用户名可以不填写，系统会用自动生成的序号作为用户名
        </p>

        <div class="btn-group">
          <el-button type="primary" @click="doSubmit">确认</el-button>
          <el-button type="default" @click="doCancel">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>


<script>
import EmployeeManagement from "../api/EmployeeManage";
export default EmployeeManagement;
</script>

<style scoped lang="scss">
.btn-head {
  display: flex;
  justify-content: end;
}
.pagination-block {
  margin-top: 20px;
}

.btn-group {
  margin-bottom: 20px;
  text-align: end;
}

.table-note {
  font-size: 14px;
  text-align: left;
}
</style>